var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Header'),(!_vm.session.NoSeats)?_c('Hall'):_c('SelectPlaceWithoutHall'),_c('Footer'),_vm._v("\n\n  "+_vm._s(_vm.log(_vm.session))+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }